import styled from 'styled-components';

import { Button } from 'components/button';

export const DeleteFileButton = styled(Button)`
  margin-top: 16px;
`;

export const WeeklyScheduleContainer = styled.div`
  gap: 16px;
  display: grid;
  grid-template-columns: 88px 152px 152px;
`;

export const WeeklyScheduleDay = styled.h4`
  margin-top: 24px;
`;
